// extracted by mini-css-extract-plugin
module.exports = {"badges":"Badges_badges__j8Y4a","badge":"Badges_badge__ldlOz","button":"Badges_button__pHhrp","title":"Badges_title__mReof","poweredBy":"Badges_poweredBy__1fjYG"};